import { useRef, useImperativeHandle, forwardRef } from 'react';
import { Spinner } from '@koob/margaret';
import { KoobInputText } from '@koob/ui';
import { useTranslation } from 'react-i18next';

const Search = (
  {
    variant,
    onChange,
    placeholder,
    size,
    value,
    isLoading,
    onClear = () => {},
    ...props
  },
  ref,
) => {
  const inputRef = useRef();
  const { t } = useTranslation('misc');

  useImperativeHandle(ref, () => ({
    focus: () => {
      if (Boolean(inputRef.current)) {
        inputRef.current.focus();
      }
    },
  }));

  return (
    <KoobInputText
      ref={inputRef}
      type="text"
      onChange={(e) => onChange(e.target.value)}
      value={value}
      placeholder={placeholder || t('search')}
      autoComplete="none"
      data-testid="search-input"
      iconLeft={
        <i
          className="fa-light fa-magnifying-glass"
          style={{ fontSize: 20 }}
          aria-label={t('search')}
        />
      }
      iconRight={
        isLoading ? (
          <Spinner variant="button" />
        ) : Boolean(value) ? (
          <i className="fa-light fa-circle-xmark" style={{ fontSize: 20 }} />
        ) : null
      }
      onIconRightClick={
        Boolean(value) && !isLoading
          ? () => {
              onChange('');
              onClear();
            }
          : undefined
      }
      {...props}
    />
  );
};

export default forwardRef(Search);
